import { EventCatalogFromKeys, EventType } from "../types";

export const DocsEventKeys = {
  DOCS_NAVIGATION_LINK_CLICK: "docs-navigation-link-click",
  /** Docs search: debounced query with counts only (no raw search text). */
  DOCS_SEARCH_PERFORMED: "docs-search-performed",
} as const;

export const DocsEventCatalog: EventCatalogFromKeys<typeof DocsEventKeys> = {
  [DocsEventKeys.DOCS_NAVIGATION_LINK_CLICK]: {
    description: "User clicked a documentation navigation link",
    eventType: EventType.BUTTON_CLICK,
    id: DocsEventKeys.DOCS_NAVIGATION_LINK_CLICK,
  },
  [DocsEventKeys.DOCS_SEARCH_PERFORMED]: {
    description:
      "User searched documentation (aggregated: word count, result count, scope)",
    eventType: EventType.FILTER,
    id: DocsEventKeys.DOCS_SEARCH_PERFORMED,
  },
};
